module.exports = __webpack_public_path__ + "assets/7a927f9c138fa890d081915d7882eb35.mp3";